import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { router }      from './router'
import { queryClient } from './lib/queryClient'
import { useAuthStore } from './store/authStore'
import './index.css'

// Activar mocks de API si VITE_MOCK_API=true (solo en desarrollo)
if (import.meta.env.VITE_MOCK_API === 'true') {
  const { setupMocks } = await import('./services/mocks')
  setupMocks()
}

await useAuthStore.getState().hydrateSession()

const root = document.getElementById('root')
if (!root) throw new Error('No se encontró el elemento #root en el DOM')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          classNames: {
            toast:       'font-sans text-sm',
            description: 'font-sans text-xs text-text-muted',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>
)
